<div class="forgottenpassword-container">
    <mat-card class="default-card">
        <mat-card-header>
            <mat-card-title>{{ 'ForgottenPassword.Title' | translate }}</mat-card-title>
        </mat-card-header>
        <form [formGroup]="forgottenPasswordForm" (ngSubmit)="onSubmit()">
            <mat-card-content>
                <div class="forgottenpassword-form">
                    <mat-form-field appearance="outline" style="width: 300px">
                        <mat-label>{{ 'ForgottenPassword.InputLoginPlaceholder' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'ForgottenPassword.InputLoginPlaceholder' | translate }}" formControlName="login" required />
                        @if (forgottenPasswordForm?.get('login').hasError('pattern')) {
                            <mat-error>{{ 'ForgottenPassword.LoginPatternError' | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-stroked-button class="accent-button" type="button" (click)="cancel()">{{ 'ForgottenPassword.CancelButton' | translate }}</button>
                <button mat-raised-button class="accent-button" [disabled]="!forgottenPasswordForm?.valid" type="submit">
                    {{ 'ForgottenPassword.SubmitButton' | translate }}
                </button>
            </mat-card-actions>
        </form>
    </mat-card>
</div>
